import { Backdrop, CircularProgress } from '@mui/material';
import axios from 'axios';
import React, { createContext, useEffect, useReducer, useState } from 'react';
import { reducer } from './Services/reducer/reducer';
import { initialState } from './Services/reducer/initialState';
import AuthServices from './Services/AuthServices';

export const HttpContext = createContext(false);

export const HttpContextProvider = ({ children }) => {
  const token = localStorage.getItem("token")
  const [isLoader, setLoader] = useState(false)

  const [state, dispatch] = useReducer(reducer, initialState);

  useEffect(() => {
    AuthServices(dispatch);
  }, [])

  const currentPath = window.location.pathname
  if (token == null && currentPath != "/login" && currentPath != "/register") {
    window.location.href = "/login"
  }
  const httpClient = axios.create({
    baseURL: window.location.hostname === "goskluch.pro" ? "https://api.signself.ru/api" : "https://api.xn----7sbbnf1adhdtdh6a.xn--p1ai/api",
    headers: {
      Authorization: `Bearer ${token}`
    },
  });

  httpClient.interceptors.request.use(function (config) {
    if (!config.url.includes("address")) {
      setLoader(true)
    }
    return config;
  })
  httpClient.interceptors.response.use(function (response) {
    setLoader(false)
    if (response.config.method === "post" || response.config.method === "put") {
      alert("Успешно")
    }
    return response;
  }, function (error) {
    setLoader(false)
    if (error.response?.status === 400) {
      alert(JSON.stringify(error.response.data))
    }
    if (error.response?.status === 401) {
      window.location.href = "/login"
    }
    return Promise.reject(error);
  });
  return (
    <React.Fragment>
      {
        window.location.hostname !== "goskluch.pro" &&
        <Backdrop
          sx={{ color: '#fff', zIndex: 999 }}
          open={isLoader}
        >  <CircularProgress color="inherit" />
        </Backdrop>

      }
      <HttpContext.Provider value={{ httpClient, state, dispatch }}>
        {children}
      </HttpContext.Provider>
    </React.Fragment>

  );
};
